import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";

// Font hosts: warm up the connections before any font file is requested.
const preconnects: Array<{
  href: string;
  crossOrigin?: string;
}> = [{
  href: "https://fonts.googleapis.com"
}, {
  href: "https://fonts.gstatic.com",
  crossOrigin: "anonymous"
}];
preconnects.forEach(({
  href,
  crossOrigin
}) => {
  if (document.head.querySelector(`link[rel="preconnect"][href="${href}"]`)) return;
  const link = document.createElement("link");
  link.rel = "preconnect";
  link.href = href;
  if (crossOrigin) link.crossOrigin = crossOrigin;
  document.head.insertBefore(link, document.head.firstChild);
});
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-262" data-mp="2tzepcnz979yf" />);
}